export default __webpack_public_path__ + "static/media/do-1@2x.d4fcb5bd.jpg";